import ConditionProps from './parts/ConditionProps';
import { is } from 'bpmn-js/lib/util/ModelUtil';

const LOW_PRIORITY = 500;

export default class ConditionPropertiesProvider {

  constructor(propertiesPanel, translate) {
    
    this.getGroups = function (element) {
      return function (groups) {
        // Add the new group
        if (is(element, 'bpmn:SequenceFlow')) {
          // Seulement si l'élément source (d'où part la flèche) est un Gateway
          // (les 2 types gérés étant : bpmn:ExclusiveGateway et bpmn:ParallelGateway)
          if (element.source && (is(element.source, 'bpmn:ExclusiveGateway') || is(element.source, 'bpmn:ParallelGateway'))) {
            groups.push(createConditionGroup(element, translate));
          }
        }
        return groups;
      };
    };

    // Use a lower priority to ensure it is loaded after the basic BPMN properties.
    propertiesPanel.registerProvider(LOW_PRIORITY, this);
  }
}

ConditionPropertiesProvider.$inject = [ 'propertiesPanel', 'translate' ];

// Create the custom group called "Condition".
function createConditionGroup(element, translate) {

  const conditionGroup = {
    id: 'condition',
    label: translate('Condition'),  
    entries: ConditionProps(element),
    // tooltip: translate('Group tooltip')
  };

  return conditionGroup;
}